import React from 'react';

const EventContent = ({
    eventInfo,
    productText,
    totalAvailabilityText,
    lowestRateText,
}) => {
    return (
        <div>
            <b>{eventInfo.timeText}</b>
            <i>{`${eventInfo.event.extendedProps.count} ${productText}`}</i>
            <div>
                {Object.values(eventInfo.event.extendedProps.qualities).map(
                    (quality, index) => (
                        <span key={index} style={{ marginRight: '10px' }}>
                            {quality.icon} {quality.count}
                        </span>
                    )
                )}
            </div>
            <div>
                <b>{totalAvailabilityText}: </b>
                {eventInfo.event.extendedProps.totalAvailability}
            </div>
            <div>
                <b>{lowestRateText}: </b>
                {eventInfo.event.extendedProps.lowestRate !== Infinity
                    ? eventInfo.event.extendedProps.lowestRate
                    : 'No disponible'}
            </div>
        </div>
    );
};

export default EventContent;
